export default __webpack_public_path__ + "static/media/download.0056a6a4.svg";